/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const ModalDialog = (props) => {
    
    const { location, zIndex, children } = props;
    
    return (
        <div
            className='modal'
            style={{
                top: location.top,
                left: location.left,
                zIndex,
                position: "absolute",
                marginTop: "12px",
            }}
        >
            {children}
        </div>
    );
};

export default ModalDialog;
